import { BetBuilderEventsType } from "app/types/betBuilderType";
import cloneDeep from "lodash/cloneDeep";
import has from "lodash/has";
import isEmpty from "lodash/isEmpty";
import store from "../store/store";
import type { CompetitionType } from "../types/competitionType";
import type { EventMarketType, EventType } from "../types/eventType";
export default class OddsLogic {
  // Update the odds for event list and single event
  static updateOdds(newOdds: any) {
    if (store.getState().competitionListModel.unsummarizedMarketsModalEvent) {
      // Update the odds for the showUnsummarizedMarketsModalEvent
      let unsummarizedMarketsModalEvent: EventType = cloneDeep(
        store.getState().competitionListModel.unsummarizedMarketsModalEvent
      );
      newOdds.forEach(odds => {
        updateSingleEvent(unsummarizedMarketsModalEvent, odds, newOdds);
      });
      store.dispatch.competitionListModel.updateUnsummarizedMarketsModalEvent(
        unsummarizedMarketsModalEvent
      );
    }

    // Get the competition list
    let competitionList: CompetitionType[] = cloneDeep(
      store.getState().competitionListModel.competitionList
    );
    // Get the event list and single event
    let singleEvent: EventType = cloneDeep(
      store.getState().singleEventModel.singleEvent
    );
    let betSlipList: EventType[] = cloneDeep(
      store.getState().betSlipListModel.betSlipList
    );

    const betBuilderEvents: BetBuilderEventsType =
      store.getState().betBuilderModel.betBuilderEvents;

    const betBuilderEventIds: number[] = Object.keys(betBuilderEvents).map(
      id => +id //convert string to number
    );

    // Go through the list of price updates
    newOdds.forEach(odds => {
      // check if the odds update is in betBuilder
      if (betBuilderEventIds.includes(odds.eventId)) {
        store.dispatch.betBuilderModel.updatePricesFromWS(odds);
      }

      // Go through the event list's markets
      updateCompetitionList(competitionList, odds, newOdds);
      // Go through the singleEvent's markets
      updateSingleEvent(singleEvent, odds, newOdds);
      // Go through the bet slip list's markets
      updateEventList(betSlipList, odds, newOdds);
    });

    // Update the Competition List
    store.dispatch.competitionListModel.updateCompetitionList({
      competitionList,
    });
    // Update the Single Event
    store.dispatch.singleEventModel.setEvent(singleEvent);
    // Update the Bet Slip List
    store.dispatch.betSlipListModel.updateBetSlipList({
      betSlipList,
    });
  }
}
/*
 ** INTERNAL METHODS
 */
// method to update event list

function updateCompetitionList(
  competitionList: CompetitionType[],
  odds: any,
  newOdds: any
) {
  competitionList.length > 0 &&
    newOdds.forEach(newOdd => {
      const comp = competitionList.find(
        competition => competition.id === newOdd.competitionId
      );

      if (comp === undefined) {
        return;
      }

      const event = comp.events.find(event => event.id === newOdd["eventId"]);

      if (!isEmpty(event) && event) {
        // check if the event has alternativeMarketPeriods
        if (!isEmpty(event.alternativeMarketPeriods)) {
          event.alternativeMarketPeriods.forEach(mp => {
            mp.marketTypes &&
              mp.marketTypes.forEach(mt => {
                updateOddsInMarkets(mt.markets, odds, newOdds);
              });
          });
        }

        if (!isEmpty(event.marketPeriods)) {
          return competitionList
            .find(competition => competition.id === newOdd.competitionId)
            .events.find(event => event.id === newOdd["eventId"])
            .marketPeriods.find(marketPeriod => {
              if (!isEmpty(marketPeriod.marketTypes)) {
                let foundMarketPeriod = marketPeriod.marketTypes.find(
                  marketType => {
                    if (!isEmpty(marketType.markets)) {
                      // Find the market with specific market id
                      // returns true if the odds were updated
                      return updateOddsInMarkets(
                        marketType.markets,
                        odds,
                        newOdds
                      );
                    }

                    return false;
                  }
                );
                // returns true if the odds were updated
                return foundMarketPeriod != null;
              }

              return false;
            });
        }
      }
    });
}

// method to update event list
function updateEventList(eventList: EventType[], odds: any, newOdds: any) {
  eventList.find(event => {
    if (!isEmpty(event.markets)) {
      // Find the market with specific market id
      // returns true if the odds were updated
      return updateOddsInMarkets(event.markets, odds, newOdds);
    }

    return false;
  });
}

// method to update single event
function updateSingleEvent(singleEvent: EventType, odds: any, newOdds: any) {
  if (!isEmpty(singleEvent)) {
    if (!isEmpty(singleEvent.marketPeriods)) {
      singleEvent.marketPeriods.find(marketPeriod => {
        if (!isEmpty(marketPeriod.marketTypes)) {
          let foundMarketPeriod = marketPeriod.marketTypes.find(marketType => {
            if (!isEmpty(marketType.markets)) {
              // Find the market with specific market id
              // returns true if the odds were updated
              return updateOddsInMarkets(marketType.markets, odds, newOdds);
            }

            return false;
          });
          // returns true if the odds were updated
          return foundMarketPeriod != null;
        }

        return false;
      });
    } // asian
    // if (!isEmpty(singleEvent.marketPeriodsSummary)) {
    //   singleEvent.marketPeriodsSummary.forEach(marketPeriod => {
    //     marketPeriod.marketTypes.forEach(marketType => {
    //       updateOddsInMarkets(marketType.markets, odds, newOdds);
    //     });
    //   });
    // }
    // if (!isEmpty(singleEvent.marketPeriodsAdditional)) {
    //   singleEvent.marketPeriodsAdditional.forEach(marketPeriod => {
    //     marketPeriod.marketTypes.forEach(marketType => {
    //       updateOddsInMarkets(marketType.markets, odds, newOdds);
    //     });
    //   });
    // }
    // if (!isEmpty(singleEvent.marketPeriodsCorners)) {
    //   singleEvent.marketPeriodsCorners.forEach(marketPeriod => {
    //     marketPeriod.marketTypes.forEach(marketType => {
    //       updateOddsInMarkets(marketType.markets, odds, newOdds);
    //     });
    //   });
    // }
  }
}

// General function to update the odds in a list of markets
function updateOddsInMarkets(
  markets: EventMarketType[],
  odds: any,
  newOdds: any
) {
  let foundMarkets = markets.find(market => {
    if (market && market.id === odds["marketId"]) {
      if (!isEmpty(market.runners)) {
        // Find the runner with specific runner id
        let foundMarket = market.runners.find(runner => {
          if (runner.id === odds["id"]) {
            // Check if the odds exist
            if (
              has(runner, "aggregatedPrices") &&
              !isEmpty(runner["aggregatedPrices"]) &&
              has(odds, "aggregatedPrices") &&
              !isEmpty(odds["aggregatedPrices"])
            ) {
              // Check if the odds improved or shortened
              if (
                runner["aggregatedPrices"][0].odds <
                odds["aggregatedPrices"][0].odds
              ) {
                // Odds improved
                runner.oddsImproved = true;
                runner.oddsShortened = false;
              } else if (
                runner["aggregatedPrices"][0].odds >
                odds["aggregatedPrices"][0].odds
              ) {
                // Odds shortened
                runner.oddsImproved = false;
                runner.oddsShortened = true;
              } else {
                // No change
                runner.oddsImproved = false;
                runner.oddsShortened = false;
              }
            }

            // Update the prices
            runner["aggregatedPrices"] = odds["aggregatedPrices"];
            runner.isWebsocketPrice = odds.isWebsocketPrice;
            // Clear any previous timeouts
            runner.timeout && clearTimeout(runner.timeout);

            // Reset the odds after 3 sec
            if (runner.oddsImproved || runner.oddsShortened) {
              runner.timeout = setTimeout(() => resetFlashOdds(newOdds), 3000);
            }

            // return true to the parent find, as runner is found and odds are updated
            return true;
          }

          return false;
        });
        // return true to the parent find, if market is found and odds are updated
        return foundMarket != null;
      }
    }

    return false;
  });
  // returns true to the caller, if the odds were updated
  return foundMarkets != null;
}

// Reset the booleans for odds improved/shortened
function resetFlashOdds(newOdds: any) {
  let competitionList: CompetitionType[] = cloneDeep(
    store.getState().competitionListModel.competitionList
  );
  let singleEvent: EventType = cloneDeep(
    store.getState().singleEventModel.singleEvent
  );
  let betSlipList: EventType[] = cloneDeep(
    store.getState().betSlipListModel.betSlipList
  );
  newOdds.forEach(odds => {
    resetListCompetitionEventOdds(competitionList, odds);
    resetSingleEventOdds(singleEvent, odds);
    resetListEventOdds(betSlipList, odds);
  });
  // Update the Event List
  store.dispatch.competitionListModel.updateCompetitionList({
    competitionList,
  });
  // Update the Single Event
  store.dispatch.singleEventModel.setEvent(singleEvent);
  // Update the Bet Slip List
  store.dispatch.betSlipListModel.updateBetSlipList({
    betSlipList,
  });
}

function resetSingleEventOdds(singleEvent: EventType, odds: any) {
  // check if there is a single event
  if (!isEmpty(singleEvent)) {
    // check if it has any market periods
    if (!isEmpty(singleEvent.marketPeriods)) {
      // go through the market periods
      singleEvent.marketPeriods.find(marketPeriod => {
        // check if the market period has market types
        if (!isEmpty(marketPeriod.marketTypes)) {
          // go through the market types
          let foundMarketType = marketPeriod.marketTypes.find(marketType => {
            // reset the odds in the markets
            return resetOdds(marketType.markets, odds);
          });
          return foundMarketType != null;
        }

        return false;
      });
    }
  }
}

function resetListCompetitionEventOdds(
  competitionList: CompetitionType[],
  odds: any
) {
  if (competitionList.length > 0) {
    if (
      competitionList.find(
        competition => competition.id === odds.competitionId
      ) === undefined
    ) {
      return;
    }

    let event = competitionList
      .find(competition => competition.id === odds.competitionId)
      .events.find(event => event.id === odds["eventId"]);

    if (!isEmpty(event)) {
      // check if it has any market periods
      if (!isEmpty(event.marketPeriods)) {
        // go through the market periods
        event.marketPeriods.find(marketPeriod => {
          // check if the market period has market types
          if (!isEmpty(marketPeriod.marketTypes)) {
            // go through the market types
            let foundMarketType = marketPeriod.marketTypes.find(marketType => {
              // reset the odds in the markets
              if (!isEmpty(event)) {
                // check if it has any market periods
                if (!isEmpty(event.marketPeriods)) {
                  // go through the market periods
                  event.marketPeriods.find(marketPeriod => {
                    // check if the market period has market types
                    if (!isEmpty(marketPeriod.marketTypes)) {
                      // go through the market types
                      let foundMarketType = marketPeriod.marketTypes.find(
                        marketType => {
                          // reset the odds in the markets
                          return resetOdds(marketType.markets, odds);
                        }
                      );
                      return foundMarketType != null;
                    }

                    return false;
                  });
                }
              }

              return resetOdds(marketType.markets, odds);
            });
            return foundMarketType != null;
          }

          return false;
        });
      }
    }
  }
}

function resetListEventOdds(eventList: EventType[], odds: any) {
  eventList.find(event => {
    // reset the odds in the markets
    return resetOdds(event.markets, odds);
  });
}

function resetOdds(markets: EventMarketType[], odds: any) {
  if (!isEmpty(markets)) {
    // go through the markets
    let foundMarket = markets.find(market => {
      // check if the market has any runners
      if (market && !isEmpty(market.runners)) {
        // go through the runners
        let foundRunner = market.runners.find(runner => {
          // reset the odds for that odd.
          if (runner.id === odds["id"]) {
            runner.oddsImproved = false;
            runner.oddsShortened = false;
            // found the odd and reset it
            return true;
          } else {
            return false;
          }
        });
        return foundRunner != null;
      }

      return false;
    });
    return foundMarket != null;
  }

  return false;
}
